import { GetterTree } from 'vuex';
import { State } from '@/stores/environment/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public environment = (state: State) => state.environment;
    public version = (state: State) => state.version;
}
